import { ElasticApmServerUrl, env, PlatformApiFallbackUrl, PlatformApiUrl, version } from "config";

import { ApmBase, init } from "@elastic/apm-rum";

let apm: ApmBase;

const mockApm = {
  captureError(error: unknown) {
    console.debug("[MockApm] captureError:", error);
  },
  setUserContext(context: unknown) {
    console.debug("[MockApm] setUserContext:", context);
  },
  setCustomContext(context: unknown) {
    console.debug("[MockApm] setCustomContext:", context);
  },
  addFilter(_fn: unknown) {
    // no-op: no payload filtering needed in mock
  },
};

function getApm() {
  if (!apm) {
    throw new Error("Elastic APM has not been initialized yet");
  }

  return apm;
}

function initApm() {
  if (!apm) {
    if (env === "development" && !ElasticApmServerUrl) {
      apm = mockApm as unknown as ApmBase;
    } else {
      apm = init({
        active: ["production", "staging"].includes(env),
        distributedTracingOrigins: [PlatformApiUrl, PlatformApiFallbackUrl],
        environment: env,
        propagateTracestate: true,
        serverUrl: ElasticApmServerUrl,
        serviceVersion: version as string,
        serviceName: "Wyshware Web",
      });
    }
  }

  apm.addFilter(function (payload) {
    if (payload.transactions) {
      payload.transactions.forEach(function (transaction) {
        transaction.spans?.forEach(function (span) {
          if (span.context?.custom?.path) {
            span.context.custom.path = undefined;
          }
        });
      });
    }

    return payload;
  });

  return apm;
}

export { getApm as get, initApm as init };
